import { WIDGET_COLORS } from '../../constants/colors';
import { formatPoints, formatCurrency, downPaymentPercent, formatDate } from '../../utils/formatSavingsPoints';
import type { SavingsPointsData } from '../../hooks/useGetSavingsPoints';
import { WidgetCardHeader } from '../widgetCardHeader';
import { WidgetDivider } from '../widgetDivider';
import { ProgressItem } from '../progressItem';
import { DipTimeline } from '../dipTimeline';
import { WidgetNotice } from '../widgetNotice';

type Props = { data: SavingsPointsData };

export function DipInProgress({ data }: Props) {
  const investmentNum = parseFloat(data.total_investment);
  const additionalNum = parseFloat(data.additional_downpayment_needed);
  const dpTarget = (investmentNum + additionalNum).toString();
  const dpPercent = downPaymentPercent(data.total_investment, dpTarget);

  return (
    <>
      <WidgetCardHeader
        variant="dip"
        badgeText="DIP In Progress"
        description="Your home finance application is underway - please complete your DIP form."
        descriptionColor={WIDGET_COLORS.dip.text}
        descriptionWeight={500}
      />

      <WidgetDivider />

      <ProgressItem
        label="Community Points"
        value={
          <span className="font-bold" style={{ color: WIDGET_COLORS.green.text }}>
            ✓ {formatPoints(data.savings_points_earned)} of{' '}
            {formatPoints(data.savings_points_required)} required
          </span>
        }
        barPercent={100}
        barColor={WIDGET_COLORS.green.bar}
      />

      <ProgressItem
        label="Down Payment (GYS Home balance)"
        value={
          <span className="font-bold" style={{ color: WIDGET_COLORS.green.text }}>
            ✓ {formatCurrency(data.total_investment)} of {formatCurrency(dpTarget)}
          </span>
        }
        barPercent={dpPercent}
        barColor={WIDGET_COLORS.green.bar}
      />

      {data.dip_sent_date && data.dip_expiry_date && (
        <DipTimeline
          sentDate={data.dip_sent_date}
          expiryDate={data.dip_expiry_date}
          pointsEarned={data.savings_points_earned}
        />
      )}

      <WidgetNotice variant="dip" icon="file-text">
        We have sent your Decision in Principle form - please check your email and complete it.
        {data.dip_expiry_date && (
          <> Your DIP is valid until <strong>{formatDate(data.dip_expiry_date)}</strong>.</>
        )}{' '}
        If it expires before completion, you will be removed from the queue and will need to give us
        three months&apos; notice to issue a new DIP form.
      </WidgetNotice>
    </>
  );
}
